import { Button } from './Button';

export function ProjectModal({ project, onClose }) {
  if (!project) {
    return null;
  }

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div className="modal glass-panel" role="dialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
        <button className="modal__close" type="button" onClick={onClose} aria-label="Close modal">
          ×
        </button>
        <div className={`modal__visual project-card__visual project-card__visual--${project.theme}`}>
          <img className="project-card__image" src={project.image} alt={project.imageAlt || project.title} loading="lazy" />
          <div className="project-card__liquid" aria-hidden="true">
            <span className="project-card__liquid-blob project-card__liquid-blob--one" />
            <span className="project-card__liquid-blob project-card__liquid-blob--two" />
            <span className="project-card__liquid-blob project-card__liquid-blob--three" />
          </div>
          <div className="project-card__badge-wrap">
            <span className="project-card__badge">{project.imageLabel}</span>
          </div>
        </div>
        <div className="modal__body">
          <p className="eyebrow">{project.category}</p>
          <h3 className="modal__title">{project.title}</h3>
          <p className="modal__copy">{project.details}</p>
          {project.availability?.length ? (
            <div className="modal__availability">
              {project.availability.map((item) => (
                <span className="tag" key={item}>
                  {item}
                </span>
              ))}
            </div>
          ) : null}
          <div className="tag-row">
            {project.stack.map((item) => (
              <span className="tag" key={item}>
                {item}
              </span>
            ))}
          </div>
          <p className="modal__result">{project.result}</p>
          <div className="modal__actions">
            {project.liveUrl ? <Button href={project.liveUrl}>{project.liveLabel || 'Visit Project'}</Button> : null}
            <Button to="/contact" variant="secondary">
              Start a Similar Project
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}